"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = void 0;
const axios_class_1 = require("./axios.class");
class Space {
    /**
     * Fetch spaces with stats by client.
     */
    async getSpacesByClient() {
        const { data } = await axios_class_1.axios.get(`/v1/clients/spacesWithStats`);
        return data;
    }
    /**
     * Fetch collection by space.
     */
    async getCollectionBySpace(spaceId) {
        const { data } = await axios_class_1.axios.get(`/v1/clients/spaces/${spaceId}/collections`);
        return data;
    }
    /**
     * update space
     */
    async update(spaceId, space) {
        return axios_class_1.axios.patch(`/v1/clients/spaces/${spaceId}`, space);
    }
    /**
     * create space
     */
    async create(space) {
        return axios_class_1.axios.post(`/v1/clients/space`, space);
    }
}
exports.space = new Space();
